import { BiBriefcase } from "@react-icons/all-files/bi/BiBriefcase";
import "./Resume.css"
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();
const Resume = () => {
    
  return (
    <div className="pages-page-main">
      <div className="pages-inner-content">
        <div
          className="pages-heading-div"
          data-aos="fade-up"
          data-aos-offset="0"
          data-aos-delay="0"
          data-aos-duration="1200"
          data-aos-easing="ease-out"
        >
          <BiBriefcase className="pages-page-icon" />
          <span className="pages-introduce">resume</span>
        </div>
        <div
          data-aos="fade-up"
          data-aos-offset="0"
          data-aos-delay="0"
          data-aos-duration="1200"
          data-aos-easing="ease-out"
          className="about-introduction-heading"
        >
          Education &<span className="colored-heading"> Experience</span>
        </div>
        <div
          className="practicing-skills-div"
          data-aos="fade-left"
          data-aos-offset="50"
          data-aos-delay="0"
          data-aos-duration="1200"
          data-aos-easing="ease-out"
        >
          <div className="practicing-heading">currently - working - on</div>
          <div className="practicing-skill-name">
            front-end react developer{" "}
          </div>
          <div className="practicing-skill-description">
            Learn through bulding responsive projects
          </div>
          <div className="practicing-skill-name">
            back-end nodejs developer{" "}
          </div>
          <div className="practicing-skill-description">
            Learn through bulding complex projects listed below
          </div>
        </div>
        <div
          className="leraning-skills-div"
          data-aos="fade-up-left"
          data-aos-offset="50"
          data-aos-delay="0"
          data-aos-duration="1200"
          data-aos-easing="ease-out"
        >
          <div className="practicing-heading">currently - learing </div>
          <div className="practicing-skill-name">front-end react-native </div>
          <div className="practicing-skill-description">
            Learning from cources
          </div>
          <div className="practicing-skill-name">reactjs advance to nextjs</div>
          <div className="practicing-skill-description">
            Learning from cources
          </div>
        </div>
      </div>
    </div>
  );
};
export default Resume
